import { render, staticRenderFns } from "./LogisticaDashboard.vue?vue&type=template&id=052e4054&scoped=true"
import script from "./LogisticaDashboard.vue?vue&type=script&lang=js"
export * from "./LogisticaDashboard.vue?vue&type=script&lang=js"
import style0 from "./LogisticaDashboard.vue?vue&type=style&index=0&id=052e4054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e4054",
  null
  
)

export default component.exports